import { FC } from "react"

import { Accordion, AccordionDetails, Grid, Stack } from "@mui/material"
import TextField from "components/form/common/field/textField"
import Summary from "components/form/common/formPart/transactions/accordion/summary"
import { useWatch } from "react-hook-form"

interface IProps {
  title: string
  titleFieldName: "expenseTitle" | "paycheckTitle"
  valueFieldName: "expenseValue" | "paycheckValue"
  titleLabel: string
  valueLabel: string
}

const ManualSection: FC<IProps> = ({
  title,
  titleFieldName,
  valueFieldName,
  titleLabel,
  valueLabel,
}) => {
  const titleValue: string = useWatch({ name: titleFieldName, exact: true })

  return (
    <Accordion>
      <Summary title={title} selectedItemsAmount={titleValue ? 1 : 0} />
      <AccordionDetails>
        <Stack gap="16px">
          <Grid container columnSpacing="16px" rowSpacing="40px">
            <Grid size={{ desktop: 8, tablet: 6, mobile: 12 }}>
              <TextField
                label={titleLabel}
                size="small"
                name={titleFieldName}
              />
            </Grid>
            <Grid size={{ desktop: 4, tablet: 6, mobile: 12 }}>
              <TextField
                label={valueLabel}
                size="small"
                name={valueFieldName}
              />
            </Grid>
          </Grid>
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}

export default ManualSection
